'use strict';

var $body = $('body');
var metalRatesHeight;
var isLoggedin = $('#isAuthenticated').val();
var loadExternalScript = require('../utils/loadExternalScript');
var loadExternalStyle = require('../utils/loadExternalStyle');
var toastMessageHelper = require('../utils/toastMessageHelper');
var googleTranslateHelperPromise;

/**
 * Calculates and sets the height for the metal rates header banner based on window width.
 * @returns {void}
 */
function initMetalRateHeight() {
    if ($(window).width() < 1250) {
        metalRatesHeight = $('.metal-rates-header-banner .banner-container').height() + 24;
    } else {
        metalRatesHeight = $('.metal-rates-header-banner .banner-container').height() + 1;
    }
}

/**
 * Handles the transition for showing/hiding the metal rates header banner and sets its height.
 * @returns {void}
 */
function initMetalRateHeightTransition() {
    initMetalRateHeight();
    $('.metal-rates-header-banner.show').css('height', metalRatesHeight + 'px');
    $('.metal-rates-header-banner:not(.show)').css('height', '0px');
}

/**
 * Toggles profile menu collapse behavior based on viewport width.
 *
 * - **Mobile view (<1024px)**: enables Bootstrap collapse attributes and
 *   ensures the target is collapsed.
 * - **Desktop view (≥1024px)**: removes collapse attributes and keeps the
 *   target expanded.
 *
 * @function handleProfileCollapse
 * @returns {void}
 */
function handleProfileCollapse() {
    var isMobile = window.innerWidth < 1024; // Bootstrap lg breakpoint

    $('.profile-menu-toggle').each(function () {
        var $toggle = $(this);
        var target = $toggle.attr('data-target');
        var $collapse = $(target);

        if (!target || !$collapse.length) return;

        if (isMobile) {
            $toggle.attr('data-toggle', 'collapse').addClass('collapsed');
            $collapse.addClass('collapse').removeClass('show').css('height', '');
        } else {
            $toggle.removeAttr('data-toggle').removeClass('collapsed');
            $collapse.removeClass('collapse').addClass('show').css('height', 'auto');
        }
    });
}

$body.on('click', '.metal-rate, .metal-rates-close', function () {
    $('.metal-rates-header-banner, .metal-rate').toggleClass('show');
    initMetalRateHeightTransition();

    if ($('.custom-drop-down').hasClass('opened') || $('.refinement-bar').css('display') === 'block') {
        $('.custom-option-values').fadeOut();
        $('.custom-drop-down').removeClass('opened');
        $('body').removeClass('overflow-hidden');
        $('.refinement-bar, .modal-background').hide();
    }
    $('.suggestions-wrapper').toggleClass('metal-rate-show');
});

/**
 * Loads the deferred Google Translate helper bundle on demand.
 *
 * @returns {Promise<Object>} Resolves with the helper API attached to window.
 */
function getGoogleTranslateHelper() {
    var helperScriptUrl = $('#google_translate_element').data('googleTranslateHelperScriptUrl');

    if (window.ckcGoogleTranslateLoader) {
        return Promise.resolve(window.ckcGoogleTranslateLoader);
    }

    if (!helperScriptUrl) {
        return Promise.reject(new Error('Missing Google Translate helper script source.'));
    }

    if (!googleTranslateHelperPromise) {
        googleTranslateHelperPromise = loadExternalScript(helperScriptUrl)
            .then(function () {
                if (!window.ckcGoogleTranslateLoader) {
                    throw new Error('Google Translate helper failed to initialize.');
                }

                return window.ckcGoogleTranslateLoader;
            }).catch(function (error) {
                googleTranslateHelperPromise = null;
                throw error;
            });
    }

    return googleTranslateHelperPromise;
}

$(document).ready(function () {
    if (document.cookie.indexOf('googtrans=') === -1) {
        return;
    }

    getGoogleTranslateHelper().then(function (googleTranslateHelper) {
        return googleTranslateHelper.syncFromCookie();
    }).catch(function () {
        // Leave the page untranslated when the deferred helper cannot restore state.
    });
});

$(document).on('click', '[data-target="#languages-list"]', function () {
    getGoogleTranslateHelper().then(function (googleTranslateHelper) {
        return googleTranslateHelper.preload();
    }).catch(function () {
        // Keep the selector usable even when Google Translate cannot be preloaded.
    });
});

$('#languages-list li').on('click', function () {
    var language = $(this).data('lang');

    $('[id="languages-list"]').collapse('hide');
    $('.more-section-accodian-body .countrys-wrap-list').scrollTop(0);

    getGoogleTranslateHelper().then(function (googleTranslateHelper) {
        return googleTranslateHelper.applyLanguage(language);
    }).catch(function () {
        // Leave the current language unchanged when the deferred helper cannot translate.
    });
});

/**
 * Handles updating the active country/language item in the list
 * when the language is changed.
 *
 * @param {string} newLang - The new language code.
 */
function onLanguageChange(newLang) {
    if ($('.countrys-wrap-list .countries[data-lang="' + newLang + '"]').length) {
        $('.countrys-wrap-list .countries').removeClass('active');
        $('.countrys-wrap-list .countries[data-lang="' + newLang + '"]').addClass('active');
    }
}

var $html = $('html');
new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'lang') {
            var newLang = $html.attr('lang');
            onLanguageChange(newLang);
        }
    });
}).observe($html[0], { attributes: true, attributeFilter: ['lang'] });

$(document).on('click', function (e) {
    var $target = $(e.target);
    $('.more-section-wraps').each(function () {
        var $dropdown = $(this);
        var dropdownId = '#' + $dropdown.attr('id');
        var isOutside = !$target.closest(dropdownId).length && !$target.closest('[data-target="' + dropdownId + '"]').length;
        if (isOutside) {
            $dropdown.collapse('hide');
        }
    });
});

$('.header-search-suggestions-form .search-icon').on('click', function () {
    $('.header-search-suggestions-input').focus();
});

/**
 * Initialize level-2 category items.
 * - If an item has the `is-customization` class, strip dropdown/toggle attributes and hide the arrow.
 * - Otherwise ensure the arrow is visible for real dropdowns.
 */
function initL2CategoryItems() {
    var $items = $('.l2-category-item-text');
    if (!$items.length) return;

    $items.each(function () {
        var $link = $(this);

        if ($link.hasClass('is-customization')) {
            $link.removeClass('dropdown-link dropdown-toggle')
                .removeAttr('role data-target aria-haspopup aria-expanded tabindex');
        }
    });
}

initL2CategoryItems();

$('.user-profile .user').on('click', function (e) {
    if ($(window).outerWidth() < 1024) {
        e.preventDefault();
        e.stopPropagation();
        $('.profile-nav-frame').removeClass('collapse');
        $('#profile-menu-modal').modal('show');
    }
});

/**
 * Handles responsive behavior for the profile navigation menu.
 *
 * - **Mobile view (<1024px)**:
 *   - Moves `.profile-nav-frame` into the profile menu modal.
 *   - Ensures the navigation is visible by removing the `collapse` class.
 *   - Skips desktop hover behavior.
 *
 * - **Desktop view (≥1024px)**:
 *   - Closes the profile menu modal if it is open.
 *   - Moves `.profile-nav-frame` back into the top navbar user profile section.
 *   - Controls show/hide behavior of the profile navigation using hover
 *     (`mouseenter` / `mouseleave`) on account and guest navigation elements.
 *
 * This function is typically called on page load and on window resize
 * to keep the profile navigation in sync with the current viewport.
 *
 * @function profileMenuNavigation
 * @returns {void}
 */
function profileMenuNavigation() {
    var isNowDesktop = $(window).outerWidth() >= 1024;

    if (!isNowDesktop) {
        // Mobile view

        if (!$('#profile-menu-modal .modal-content').find('.profile-nav-frame').length) {
            $('.profile-nav-frame').appendTo('#profile-menu-modal .modal-content');
        }

        return;
    }

    // Desktop view

    var $profileModal = $('#profile-menu-modal');

    if ($profileModal.hasClass('show')) {
        $('.profile-nav-frame').addClass('collapse');
        $profileModal.modal('hide');
    }

    if (!$('.top-navbar .user-profile').find('.profile-nav-frame').length) {
        $('.profile-nav-frame').appendTo('.top-navbar .user-profile');
    }

    $('#myaccount, .profile-nav-frame').on('mouseenter', function () {
        if ($(window).outerWidth() >= 1024) {
            $('.profile-nav-frame').removeClass('collapse');
            $('.more-section-accodian-body').removeClass('show');
            $('.more-first-set-accordian').addClass('collapsed');
        }
    }).on('mouseleave', function () {
        if ($(window).outerWidth() >= 1024) {
            $('.profile-nav-frame').addClass('collapse');
        }
    });

    $('.guest-nav, .profile-nav-frame').on('mouseenter', function () {
        if ($(window).outerWidth() >= 1024) {
            $('.profile-nav-frame').removeClass('collapse');
            $('.more-section-accodian-body').removeClass('show');
            $('.more-first-set-accordian').addClass('collapsed');
        }
    }).on('mouseleave', function () {
        if ($(window).outerWidth() >= 1024) {
            $('.profile-nav-frame').addClass('collapse');
        }
    });
}

$(window).on('resize', function () {
    initMetalRateHeightTransition();
    profileMenuNavigation();
    handleProfileCollapse();
});

if (window.innerWidth > document.documentElement.clientWidth) {
    $('body').addClass('space-reserving-scrollbar'); // windows
} else {
    $('body').addClass('floating-scrollbar'); // mac, firefox
}

$('body').on('click', 'button', function () {
    $(this).blur();
});

profileMenuNavigation();
handleProfileCollapse();

$body.on('click', '.profile-menu-toggle', function () {
    var $clicked = $(this);
    var clickedTarget = $clicked.attr('data-target');

    $('.profile-menu-toggle').each(function () {
        var $toggle = $(this);
        var target = $toggle.attr('data-target');

        if (target && target !== clickedTarget) {
            var $collapse = $(target);
            if ($collapse.hasClass('show')) {
                $toggle.addClass('collapsed');
                $collapse.collapse('hide');
            }
        }
    });
});

/**
 * Fix profile image URLs that are relative paths
 * @returns {void}
 */
function fixProfileImageUrl() {
    $('.account-profile-image').each(function () {
        var $img = $(this);
        var src = $img.attr('src');
        var subfolder = $('#customerLibrarySubfolder').val();

        if (src && src.indexOf(subfolder + '/') === 0) {
            var basePath = $('#customerLibraryStaticPath').val();
            var newSrc;
            if (basePath) {
                var relativeSrc = src.substring((subfolder + '/').length);
                newSrc = window.location.origin + basePath + relativeSrc;
            }
            $img.attr('src', newSrc).show();
        }
    });
}

fixProfileImageUrl();

$('#profile-menu-modal').on('shown.bs.modal', function () {
    fixProfileImageUrl();
});

$('body').on('click', '.right-nav-items.wishlist-nav-icon .wishlist-cta', function (e) {
    // Check if user is authenticated
    if ($('#isAuthenticated').val() !== 'true') {
        e.preventDefault();
        var wishlistUrl = $(this).attr('href') || $(this).data('wishlist-url');
        $('#ckc-login-modal').attr('data-redirect-url', wishlistUrl);
        $('#ckc-login-modal').modal('show');
        return false;
    }
    // If authenticated, allow default navigation to wishlist page
    return true;
});

$('#ckc-login-modal').on('hidden.bs.modal', function () {
    $('#ckc-login-modal form').removeAttr('data-redirect');
    $('#ckc-login-modal').removeAttr('data-redirect-url');
    $('#ckc-login-modal').removeClass('login-from-track-order');
});

/**
 * Load and display the track order modal via AJAX when a track-order trigger is clicked.
 */
$(document).on('click', '.track-order-footer', function (e) {
    e.preventDefault();

    if (isLoggedin === 'true') {
        var $trigger = $('.track-order-footer');
        var trackUrl = $trigger.data('url') || $trigger.attr('href');

        if (!trackUrl) {
            return;
        }

        $.spinner().start();

        $.ajax({
            url: trackUrl,
            type: 'GET',
            success: function (html) {
                var $trackOrderModal;
                var trackOrderStyleUrl;
                var openTrackOrderModal = function () {
                    $trackOrderModal.modal('show');
                    $('.header-navbar .close-category').trigger('click');
                    $.spinner().stop();
                };

                $('.track-order-modal').remove();
                $('body').append(html);
                $trackOrderModal = $('.track-order-modal').last();
                trackOrderStyleUrl = $trackOrderModal.data('trackOrderStyleUrl');

                if (!trackOrderStyleUrl) {
                    openTrackOrderModal();
                    return;
                }

                loadExternalStyle(trackOrderStyleUrl)
                    .then(function () {
                        $trackOrderModal.attr('data-styles-loaded', 'true');
                        openTrackOrderModal();
                    })
                    .catch(function () {
                        openTrackOrderModal();
                    });
            },
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        // open Login Modal
        $('#ckc-login-modal').addClass('login-from-track-order');
        $('#ckc-login-modal').modal('show');
        $('.header-navbar .close-category').trigger('click');
    }
});

/**
 * Validates Track Order form input fields (AWB number or Phone number).
 *
 * Handles:
 * - Required field validation
 * - AWB number sanitization and length validation
 * - Phone number sanitization, country-specific rules, and length validation
 * - UI error handling (invalid classes and error messages)
 *
 * @param {jQuery} $input - jQuery input element to validate
 * @param {boolean} isInput - Flag to indicate validation during typing (true) or on blur/submit (false)
 * @returns {boolean} Returns true if the input value is valid, otherwise false
 */
function trackOrderFormValidate($input, isInput) {
    var value = $input.val();
    var isValid = true;
    var $errorDiv = $input.siblings('.invalid-feedback');
    var missingError = $input.data('missing-error');
    var parseError = $input.data('parse-error');
    var awbField = $input.attr('name') === 'awbNumber' || $input.attr('id') === 'track-order-awb';
    var isPhoneField = $input.attr('name') === 'phone' || $input.attr('id') === 'track-order-input-mobile';

    $input.removeClass('is-invalid');
    if (isPhoneField) {
        $input.closest('.form-group').find('.custom-drop-down-section').removeClass('is-invalid');
    }
    $errorDiv.hide();

    if (!value) {
        isValid = false;
        $input.addClass('is-invalid');
        $errorDiv.text(missingError).show();
        if (isPhoneField) {
            $input.closest('.form-group').find('.custom-drop-down-section').addClass('is-invalid');
        }
    } else if (awbField) {
        var awbMaxLength = parseInt($input.attr('max-length'), 10) || 11;

        if (/[^a-zA-Z0-9]/.test(value)) {
            isValid = false;
        }

        var awbValue = value.replace(/[^a-zA-Z0-9]/g, '');

        if (awbValue.length > awbMaxLength) {
            awbValue = awbValue.substring(0, awbMaxLength);
        }

        if (value !== awbValue) {
            $input.val(awbValue);
            value = awbValue;
        }

        if (!isValid) {
            $input.addClass('is-invalid');
            $errorDiv.text(parseError).show();
        }
    } else if (isPhoneField) {
        var $dropdown = $input.closest('.form-group').find('.custom-drop-down-section');
        var selectedOption = $dropdown.find('.custom-option-value.selected');
        var countryCode = selectedOption.length ? selectedOption.data('id') : $dropdown.find('.selected-value').text();
        var phoneMaxLength = selectedOption.length ? parseInt(selectedOption.data('phonelength'), 10) : 10;

        if (/\D/.test(value)) {
            isValid = false;
        }

        var phoneValue = value.replace(/\D/g, '');

        if (countryCode === '+91' && /^[0-5]/.test(phoneValue)) {
            phoneValue = phoneValue.replace(/^[0-5]+/, '');
        }

        // Limit to phoneMaxLength digits
        if (phoneValue.length > phoneMaxLength) {
            phoneValue = phoneValue.substring(0, phoneMaxLength);
        }

        if (value !== phoneValue) {
            $input.val(phoneValue);
            value = phoneValue;
        }

        // Validate +91 numbers to ensure they start with 6-9
        if (countryCode === '+91' && !/^[6-9]/.test(value)) {
            isValid = false;
        } else if (value.length !== phoneMaxLength && !isInput) {
            isValid = false;
        }

        if (!isValid) {
            $input.addClass('is-invalid');
            $input.closest('.form-group').find('.custom-drop-down-section').addClass('is-invalid');
            $errorDiv.text(parseError).show();
        }
    }

    return isValid;
}

$('body').on('input change', '#track-order-form input', function () {
    trackOrderFormValidate($(this), true);
});

$('body').on('blur', '#track-order-form input', function () {
    trackOrderFormValidate($(this));
});

$(document).on('click', '#track-order-form .phone-input-field .custom-option-value', function () {
    $('.phone-input-field, #track-order-input-mobile').removeClass('is-invalid').val('');
    $('#track-order-input-mobile').siblings('.invalid-feedback').text('').hide();
});

$(document).on('click', '.track-order-submit', function (e) {
    e.preventDefault();
    var $form = $('#track-order-form');
    var isValid = true;
    var $trigger = $(this);
    var trackUrl = $trigger.data('url');
    var scrollTarget = null;
    var trackingNumber = $('#track-order-awb').val();
    var countryCode = $('#track-order-form').find('#select-country-code').text();
    var phoneNumber = $('#track-order-input-mobile').val();

    if (!trackUrl) {
        return;
    }

    $form.find('input').each(function () {
        var $input = $(this);
        if (!trackOrderFormValidate($input)) {
            isValid = false;
            // eslint-disable-next-line no-unused-vars
            if (!scrollTarget) {
                scrollTarget = $input;
            }
        }
    });

    if (!isValid) {
        if (scrollTarget) {
            var $modal = $form.closest('.modal-body');
            if ($modal.length) {
                $modal.animate({
                    scrollTop: scrollTarget.offset().top - $modal.offset().top + $modal.scrollTop() - 20
                }, 500);
            }
        }
        return;
    }

    $.spinner().start();
    $.ajax({
        url: trackUrl,
        data: { trackingNumber: trackingNumber, phoneNumber: phoneNumber, countryCode: countryCode },
        type: 'GET',
        success: function (data) {
            if (data.success) {
                window.location.href = data.redirectUrl;
            } else {
                // Handle error case, e.g. show an error message
                $.spinner().stop();
                var $errorMessage = data.error;
                toastMessageHelper.showNotification($errorMessage);
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
});
